import { AxiosResponse } from "axios";
import { ENDPOINTS } from "../../../../processes/api/endpoints";
import { Base3DApi } from "../Base3DApi";
import { IRenderSceneConfigData, IRenderSceneConfigResponse } from "./type";

export class RenderSceneApi extends Base3DApi {
  public async renderImage(
    data: IRenderSceneConfigData
  ): Promise<AxiosResponse<IRenderSceneConfigResponse>> {
    return this.axiosInstance.post(
      ENDPOINTS.CONFIGURATION.RENDER_CONFIGURATION,
      data
    );
  }
}
